const META = {
  stop_loss: { label: "Stop", color: "rgb(var(--bt-negative))" },
  trailing_stop: { label: "Trailing stop", color: "rgb(var(--bt-negative))" },
  take_profit: { label: "Take-profit", color: "rgb(var(--bt-positive))" },
  entry: { label: "Auto-buy", color: "rgb(var(--bt-gold))" },
  entry_short: { label: "Auto-short", color: "rgb(var(--bt-gold))" },
};

export const entryAsOrder = (e) => ({ id: e.id, order_type: e.position_type === "short" ? "entry_short" : "entry", target_price: e.trigger_price, shares: e.shares });

export const orderLines = (orders) => orders.map(o => ({ price: o.target_price, ...META[o.order_type] }));

export const StopDistance = ({ orders, price }) => {
  if (!orders.length || !price) return null;
  return (
    <div className="flex flex-wrap gap-2 mb-3" data-testid="stop-distance">
      {orders.map(o => {
        const m = META[o.order_type];
        const pct = (o.target_price - price) / price * 100;
        const near = (o.order_type === "stop_loss" || o.order_type === "trailing_stop") && Math.abs(pct) < 2;
        return (
          <span key={o.id} className={`inline-flex items-center gap-1.5 px-2 py-1 border font-mono text-[11px] ${near ? "border-bt-negative bg-bt-negative/10 animate-pulse" : "border-bt-border-subtle bg-bt-surface-2"}`}
            data-testid={`stop-distance-${o.order_type}`}>
            <span className="w-3 border-t-2 border-dashed" style={{ borderColor: m.color }} />
            <span style={{ color: m.color }}>{m.label}{o.order_type === "trailing_stop" ? ` ${o.trail_pct}%` : ""}</span>
            <span className="text-bt-text-primary">${o.target_price.toLocaleString(undefined, { maximumFractionDigits: 2 })}</span>
            <span className="text-bt-text-tertiary">{Math.abs(pct).toFixed(1)}% {pct < 0 ? "below" : "above"} now</span>
          </span>
        );
      })}
    </div>
  );
};
